import { render, staticRenderFns } from "./WorkflowsHero.vue?vue&type=template&id=0073d929"
import script from "./WorkflowsHero.vue?vue&type=script&lang=js"
export * from "./WorkflowsHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports